export const l_gallery_GridTemplateColumns_minmax_max = {
  "name": "--pf-l-gallery--GridTemplateColumns--minmax--max",
  "value": "1fr",
  "var": "var(--pf-l-gallery--GridTemplateColumns--minmax--max)"
};
export default l_gallery_GridTemplateColumns_minmax_max;